import {ModuleController} from "../../infrastructure/controllers/module-controller";
import {LanguageMenuModuleConfig} from "./language-menu-module.config";
import {LanguageMenuModuleStore} from "./language-menu-module.store";
import {LanguageMenuModuleHandlers} from "./handlers/language-menu-module.handlers";
import {BaseManagedService} from "../../infrastructure/domain-services/base-managed-service";

export class LanguageMenuModuleController extends ModuleController {
  static injectables = [...BaseManagedService.injectables, LanguageMenuModuleConfig, LanguageMenuModuleStore, LanguageMenuModuleHandlers];
}
